export enum ChannelType {
  Email = "email",
  PushNotification = "push"
}

export enum EntityType {
  Race = "race",
  Runner = "runner",
  Jockey = "jockey",
  Trainer = "trainer",
  Owner = "owner"
}

export const EntityLabel = {
  [EntityType.Race]: "race",
  [EntityType.Runner]: "Horse",
  [EntityType.Jockey]: "Jockey",
  [EntityType.Trainer]: "Trainer",
  [EntityType.Owner]: "Owner"
};

export enum EventType {
  All = "all",
  RaceResults = "raceResults",
  RaceDay = "raceDay",
  TimeToRace = "timeToRace"
}

export interface SubscriptionChannel {
  type: ChannelType;
}

export interface Subscription {
  eventType: EventType;
  channels: Array<SubscriptionChannel>;
}

export interface ChannelUFC {
  favoriteId: number;
  entityType: EntityType;
  entityName: string;
  entityDob?: number;
  entityRunnerId?: number;
  subscriptions: Array<Subscription>;
}

export interface Pagination {
  currentPage: number;
  totalPages: number;
  totalResults: number;
}

export interface GetAlertsResponse {
  pagination: Pagination;
  favorites: Array<ChannelUFC>;
}
